const iconName = 'el-icon-s-grid'
export default [
  {
    path: '/master',
    name: 'master',
    alwaysShow: true,
    component: () => import('@/layout/Layout'), // Parent router-view
    //redirect: '/master',
    meta: {
      order: 600,
      icon: iconName,
      //icon: 't-svg-turn-around',
      title: 'resource.master.master'
    },
    children: [
      //得意先マスタ
      {
        path: 'customerInfoMst',
        component: () => import('@/views/master/customerInfoMst'),
        name: 'customerInfoMst',
        alwaysShow: false,
        meta: {
          order: 601,
          icon: iconName,
          title: 'resource.master.customerInfoMst',
          //角色：管理者、事務、業務
          permission: ['master'],
        }
      },
      //仕入先マスタ
      {
        path: 'supplierInfoMst',
        component: () => import('@/views/master/supplierInfoMst'),
        name: 'supplierInfoMst',
        alwaysShow: false,
        meta: {
          order: 602,
          icon: iconName,
          title: 'resource.master.supplierInfoMst',
          //角色：管理者、事務、業務
          permission: ['master'],
        }
      },
       //会社情報マスタ
      {
        path: 'companyInfoMst',
        component: () => import('@/views/master/companyInfoMst'),
        name: 'companyInfoMst',
        alwaysShow: false,
        meta: {
          order: 603,
          icon: iconName,
          title: 'resource.master.companyInfoMst',
          //角色：管理者
          permission:  ['master'],
        }
      },

/*
            //担当得意先マスタ
      {
        path: 'userCustomerInfoMst',
        component: () => import('@/views/master/userCustomers'),
        name: 'userCustomerInfoMst',
        alwaysShow: false,
        meta: {
          order: 605,
          icon: iconName,
          title: 'resource.master.userCustomerInfoMst',
          //角色：管理者
          permission:  ['admin'],
        }
      },

      //得意先担当者マスタ
      {
        path: 'managerInfoMst',
        component: () => import('@/views/master/managerInfoMst'),
        name: 'managerInfoMst',
        alwaysShow: false,
        meta: {
          order: 604,
          icon: iconName,
          title: 'resource.master.managerInfoMst',
          permission:  ['admin'],
        }
      },



      //数据字典画面
      {
        path: 'domain',
        component: () => import('@/views/master/DomainManage'),
        name: 'DomainManage',
        alwaysShow: true,
        meta: {
          order: 3012,
          title: 'resource.txt.domainManage',
          icon: 't-svg-book-one',
          //系统管理员角色可见
          permission: ['90']
        }
      },

      // 版本发布通知画面
      {
        path: 'ReleaseNotification',
        component: () => import('@/views/master/ReleaseNotification'),
        name: 'ReleaseNotification',
        alwaysShow: true,
        meta: {
          order: 5301,
          title: 'resource.txt.releaseNotification',
          icon: 't-svg-send',
          //系统管理员角色可见
          permission: ['90']
        }
      }*/
    ]
  }
]
